<template>
  <footer class="download-main-footer">
    <p>联系方式: code001@xlsuyang.com   &nbsp; &nbsp;&nbsp;应用名称：小鹿</p>
    <p>客服热线/投诉热线：400-611-0000</p>
    
    <p>
      <a
        target="_blank"
        style="margin-right: 4px;"
        href="https://www.fengniaojianzhan.com/fengniao/p/7390292196729313536?actId=7390292196729313536&groupId=0&enforceWK=1"
        >《用户服务协议》</a
      >
      <a
        target="_blank"
        style="margin-right: 4px;"
        href="https://www.fengniaojianzhan.com/fengniao/p/7390293212845580120?actId=7390293212845580120&groupId=0&enforceWK=1"
        >《儿童隐私政策》</a
      >
      <a
        target="_blank"
        href="https://www.fengniaojianzhan.com/fengniao/p/7390292621687786284?actId=7390292621687786284&groupId=0&enforceWK=1"
        >《用户隐私政策》</a
      >
    </p>
    <p>公司地址：广州市黄埔区腾飞一街2号410房411房</p>
    <p>© 广东省鹿溪线上非学科培训学校有限公司</p>
    <p>
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"
        > 粤ICP备2021177004号-1
      </a>
    </p>
  </footer>
</template>

<script>
/* eslint-disable */
export default { name: "FootBar" };
</script>

<style>
#download-wrapper .download-main-footer {
  width: 100%;
  color: #849B94;
}

#download-wrapper .download-main-footer p {
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  color: #849B94;
}
</style>
